export default "//cloud.imgsmail.ru/cloud.mail.ru/178578/img/build/plus32-from-spherum.png";